{
    "name": "thot-v4-webapp",
    "version": "1.10.0.1",
    "build": "212",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "buildDev": "ng build --configuration=dev && pwsh UpdateFront.Dev.ps1",
        "build-dev": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration=dev",
        "build-ni": "ng build && pwsh UpdateFront.Dev.ps1 -incrementBuildNumber 'false'",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "build-prod": "ng build --configuration=segi && ng build --configuration=spw-qual && ng build --configuration=plux-prod",
        "build-qual": "ng build --configuration=qual",
        "build-qual2": "ng build --configuration=qual2",
        "build-vbx": "ng build --configuration=vbx",
        "build-segi": "ng build --configuration=segi",
        "build-bizzdev": "ng build --configuration=bizzdev",
        "build-spw": "ng build --configuration=spw-prod",
        "build-spw-qual": "ng build --configuration=spw-qual",
        "build-plux": "ng build --configuration=plux-prod",
        "build:stats": "ng build --stats-json",
        "analyze": "webpack-bundle-analyzer dist/plux/stats.json"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^18.2.13",
        "@angular/cdk": "^18.2.14",
        "@angular/common": "^18.2.13",
        "@angular/compiler": "^18.2.13",
        "@angular/core": "^18.2.13",
        "@angular/forms": "^18.2.13",
        "@angular/material": "^18.2.14",
        "@angular/material-luxon-adapter": "^18.2.14",
        "@angular/platform-browser": "^18.2.13",
        "@angular/platform-browser-dynamic": "^18.2.13",
        "@angular/router": "^18.2.13",
        "@auth0/angular-jwt": "^5.2.0",
        "@ckeditor/ckeditor5-angular": "^9.1.0",
        "@fortawesome/angular-fontawesome": "^0.15.0",
        "@fortawesome/fontawesome-svg-core": "^1.2.28",
        "@fortawesome/free-brands-svg-icons": "^5.13.0",
        "@fortawesome/free-regular-svg-icons": "^5.13.0",
        "@fortawesome/free-solid-svg-icons": "^5.13.0",
        "@microsoft/signalr": "^6.0.5",
        "@ngx-translate/core": "^16.0.3",
        "angular-resizable-element": "^7.0.2",
        "chart.js": "^2.9.4",
        "ckeditor5": "^44.0.0",
        "crypto-es": "^2.1.0",
        "d3": "^5.12.0",
        "exceljs": "^4.3.0",
        "file-saver": "^2.0.2",
        "install": "^0.13.0",
        "jsnlog": "^2.30.0",
        "luxon": "^3.4.4",
        "mkdirp": "^1.0.3",
        "ngx-color-picker": "^12.0.1",
        "ngx-flexmonster": "^2.9.95",
        "normalize.css": "^8.0.1",
        "rxjs": "^7.8.1",
        "save-svg-as-png": "^1.4.17",
        "tslib": "^2.0.0",
        "zone.js": "~0.14.10"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^18.2.12",
        "@angular-eslint/builder": "16.3.1",
        "@angular-eslint/eslint-plugin": "16.3.1",
        "@angular-eslint/eslint-plugin-template": "16.3.1",
        "@angular-eslint/schematics": "^18.4.3",
        "@angular-eslint/template-parser": "16.3.1",
        "@angular/cli": "^18.2.12",
        "@angular/compiler-cli": "^18.2.13",
        "@angular/language-service": "^18.2.13",
        "@types/chart.js": "^2.9.41",
        "@types/d3": "^5.7.2",
        "@types/file-saver": "^2.0.1",
        "@types/jasmine": "~3.8.0",
        "@types/jasminewd2": "~2.0.3",
        "@types/luxon": "^3.3.0",
        "@types/node": "^12.12.30",
        "@typescript-eslint/eslint-plugin": "^5.59.2",
        "@typescript-eslint/parser": "^5.59.2",
        "eslint": "^8.57.1",
        "eslint-config-prettier": "^10.1.1",
        "jasmine-core": "~3.8.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "~6.3.7",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.5.0",
        "minimist": "^1.2.8",
        "prettier": "3.5.3",
        "protractor": "~7.0.0",
        "ts-node": "^8.7.0",
        "tslint-to-eslint-config": "^2.4.0",
        "typescript": "^5.4.5",
        "webpack-bundle-analyzer": "^4.9.0"
    }
}
